var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiSelect',{attrs:{"value":_vm.actualLanguage,"options":_vm.languages,"placeholder":"Select language","label":"value","track-by":"key","allowEmpty":false,"showLabels":false},on:{"input":_vm.languageChanged}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }